module.exports = __webpack_public_path__ + "static/media/smartphone.825d5dfd.png";